import gql from 'graphql-tag';

import ConnectedEmailFields from './subfragments/ConnectedEmailFields';

export default gql`
  fragment OfficeMailboxFields on OfficeMailbox {
    __typename
    officeId
    email {
      ...ConnectedEmailFields
    }
  }

  ${ConnectedEmailFields}
`;
